import {Card} from "../../../cdx-models/Card";
import {Query} from "../../../cdx-models/utils/MakeModel";
import {statusToLabel} from "../../../lib/card-status-utils";
import {SearchCategory} from "../search-types";

type SearchStatus =
  | "deleted"
  | "unassigned"
  | "assigned"
  | "started"
  | "snoozing"
  | "blocked"
  | "review"
  | "done"
  | "archived"
  | "undone";

const labels: SearchStatus[] = [
  "unassigned",
  "assigned",
  "started",
  "snoozing",
  "blocked",
  "review",
  "done",
  "archived",
  "undone",
];
const searchStatusToLabel = {
  ...statusToLabel,
  undone: "Undone",
};

const statusToFilter = (status: SearchStatus, includeArchivedCards: boolean): Query<Card> => {
  switch (status) {
    case "deleted":
      return {visibility: "deleted"};
    case "archived":
      return {visibility: "archived"};
    case "review":
      return {derivedStatus: "review"};
    case "blocked":
      return {derivedStatus: "blocked"};
    case "done":
      return {
        derivedStatus: includeArchivedCards
          ? ["done", "archivedDone", "heroDone", "archivedHeroDone"]
          : ["done", "heroDone"],
      };
    case "undone":
      return {
        status: {op: "neq", value: "done"},
        isDoc: [false, null],
        visibility: includeArchivedCards ? ["default", "archived"] : "default",
      };
    case "started":
      return {derivedStatus: "started"};
    case "snoozing":
      return {derivedStatus: "snoozing"};
    case "assigned":
      return {derivedStatus: "assigned"};
    case "unassigned":
      return {derivedStatus: "unassigned"};
    default:
      throw new Error(`unknown status: '${status}'`);
  }
};

const statusCategory: SearchCategory<SearchStatus> = {
  label: "Workflow state",
  key: "status",
  getSuggestions({input}) {
    if ("status".startsWith(input)) return labels;
    if ("state".startsWith(input)) return labels;
    return labels.filter((s) => s.toLowerCase().startsWith(input));
  },
  valueToKey(val) {
    return val;
  },
  valuesToDbQuery(values, {includeArchivedCards}) {
    if (values.length === 1) return statusToFilter(values[0], includeArchivedCards);
    return {$or: values.map((val) => statusToFilter(val, includeArchivedCards))};
  },
  renderSuggestion(value) {
    return searchStatusToLabel[value];
  },
  savedSearchLabel(value) {
    return {
      prio: 1,
      label: searchStatusToLabel[value].toLowerCase(),
    };
  },
};

export default statusCategory;
